<template>
  <div class="pastille" :class="[typeItem, { active }]" @click="e => $emit('click')"><div class="bubble"><span></span></div><div class="badge"></div></div>
</template>

<script>
  export default {
    props: ['typeItem', 'active']
  }
</script>

<style>

  .pastille { 
    position: relative;
    display: inline-block;
    margin: 0 0 0 10px;
    cursor: pointer;
  }
  .pastille .bubble {
    background: white;
    border: 3px solid #413492;
    border-radius: 15px;
    color: #413492;
    font-size: 21px;
    padding: 10px 15px;
    min-width: 190px;
    top: -140px;
    left: 50%;
    margin-left: -95px;
    text-align: center;
    display: inline-block;
    font-family: 'damionregular';
    position: absolute;
    pointer-events: none;
    opacity: 0;
    transition: all 0.4s ease;
  }
  .pastille .bubble:before,
  .pastille .bubble:after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 20px 0px 20px;
    border-color: #413492 transparent transparent transparent;
    position: absolute;
    left: 73px;
    bottom: -20px;
  }  
  .pastille .bubble:after {
    border-color: #ffffff transparent transparent transparent;
    left: 73px;
    bottom: -15px;
  }  
  .pastille:hover .bubble {
    top: -90px;
    opacity: 1;
  }
  .pastille .badge {
    display: inline-block;
    background: #c3c3c3;
    border: 3px solid #a28f8f;
    width: 55px;
    height: 55px;
    border-radius: 150px;
    color: white;
    font-size: 24px;
    margin-top: -65px;
    margin-bottom: 25px;
    text-align: center;
    padding: 6px;
  }
  .pastille.active .badge,
  .pastille:hover .badge {
    background: #de2128;
    border: 3px solid #7f0004;
  }
  .pastille .badge:before {
    content: "\f02d";
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    position: relative;
    font-weight: 900;
  }
  .pastille .bubble span:before { 
    content: 'Documents';
    display: inline-block;
  }
  
  .pastille.date .badge:before { content: "\f073"; }
  .pastille.date span:before { content: "Rendez-vous"; }
  
  .pastille.tous.active .badge, .pastille.tous:hover .badge {  background: #492e98; border-color: #240f60;  }
  .pastille.tous .badge:before { content: "\f02c"; }
  .pastille.tous span:before { content: "Tous"; }
  
  .pastille.alerte.active .badge, .pastille.alerte:hover .badge,
  .pastille.bd.active .badge, .pastille.bd:hover .badge   {  background: #086fab; border-color: #403592;  }
  
  .pastille.bd .badge:before { content: "\f086"; }
  .pastille.bd span:before { content: "Bandes dessinées"; }
  
  .pastille.article .badge:before { content: "\f1c5"; }
  .pastille.article span:before { content: "Documents Illustrés"; }
  
  .pastille.badge .badge:before { content: "\f0a3"; }
  .pastille.badge span:before { content: "Badge"; }
  .pastille.badge.active .badge, .pastille.badge:hover .badge {  background: #e3e039; border-color: #9f9d12;  }

  .pastille.alerte .badge:before { content: "\f0f3"; }
  .pastille.alerte span:before { content: "Notifications"; }
  
  .pastille.video.active .badge, .pastille.video:hover .badge, 
  .pastille.game.active .badge, .pastille.game:hover .badge   {  background: #e3e039; border-color: #c2b81b;  }
  .pastille.video .badge:before { content: "\f144";}
  .pastille.video.active .badge:before, .pastille.video:hover .badge { content: "\f144";color: #414141;}
  .pastille.video span:before { content: "Vidéos"; }
   
  .pastille.game .badge:before { content: "\f005";}
  .pastille.game.active .badge:before, .pastille.game:hover .badge { content: "\f005";color: #414141;}
  .pastille.game span:before { content: "Jeux"; }
  
  .pastille.message.active .badge, .pastille.message:hover .badge {  background: #4dde44; border-color: #139a0a;  }
  .pastille.message .badge:before { content: "\f075"; }
  .pastille.message span:before { content: "Ma Communauté"; }
  
</style>
